console.log("hfg");

function setCookie(name, value, minutes) {
  var expires = "";
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}


$(document).ready(function() {
  var popup = $("#pop-up-home");
  var closeButton = $("#landing-btn");
  var popupClosedCookie = getCookie("popupClosed");
  
  if (!popupClosedCookie) {
    popup.show();
  } else {
    var timeLeft = (60 * 60 * 1000) - (new Date().getTime() - popupClosedCookie);
    console.log({timeLeft});
    if (timeLeft <= 0) {
      popup.show();
    } else {
      popup.hide();
    }
  }
  
  closeButton.click(function() {
    setCookie("popupClosed", new Date().getTime(), 60);
    popup.hide();
  });

  var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname && !links[i].getAttribute('href').includes('javascript') ) { 
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
  
});
const loadMoreMobile = document.getElementById('loadMoreIconsMobile');
if (loadMoreMobile) {
  loadMoreMobile.addEventListener('click', function() {
    const items = document.querySelectorAll('.logo-list__item');
    
    items.forEach(item => {
      if (item.classList.contains('load-more')) {
        item.classList.remove('load-more');
        item.classList.add('always-visible');
      }
    });
  });
}

